<template>
  <DataTable
    no-results-message="Create an organization to invite your team mates"
    data-id="organizations-table"
    :disable-delete="true"
    :enable-delete-all="true"
    :fields="fields"
    :items="organizations || []"
    :loading="loading"
    icon="organizationUsers"
    :title="'Organizations'"
    :disable-sort="true"
    :enable-date-picker="false"
    :no-card="noCard"
    @delete="deleteOrganization"
    @delete-all="deleteAll"
    @edit="onEdit"
    @new="createOrg"
    @refresh="refresh"
  />
</template>
<script setup lang="ts">
import type { Organization } from '@mailslurp/admin-sdk';
import DataTable from '../../components/table/parts/DataTable.vue';
import type { DataTableEditResult } from '../../lib/services/types';
import type { Field } from '../../lib/services/helpers';
import { loadFetch } from '../../lib/services/helpers';
import { onMounted, ref } from 'vue';
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import { navigateTo } from '#imports';

defineProps<{
  noCard?: boolean;
}>();
const loading = ref(false);
const fields = ref<Field<Organization>[]>([
  {
    key: 'id',
    label: 'ID',
    uuid: true,
    supplyTo: (t: Organization) => `/organizations/${t.slug}`,
  },
  { key: 'name', label: 'Name' },
  { key: 'slug', label: 'Slug' },
  { key: 'createdAt', ago: true, label: 'Created' },
]);

const store3 = useStore3();

const { organizations } = storeToRefs(store3);

onMounted(async () => {
  await refresh();
});

const deleteOrganization = async (org: Organization) => {
  await loadFetch(() => store3.deleteOrganization(org.slug), store3, loading);
};

const deleteAll = async () => {
  await loadFetch(() => store3.deleteOrganizationAndUsers(), store3, loading);
};

const refresh = async () => {
  await loadFetch(() => store3.getOrganizations(), store3, loading);
};

const createOrg = async () => {
  await navigateTo('/organizations/create');
};

const onEdit = async (org: DataTableEditResult<Organization>) => {
  await navigateTo(`/organizations/${org.item.slug}`);
};
</script>
